export default __webpack_public_path__ + "static/media/CBSE_image.dda7658e.jpeg";